import React, { useContext, useEffect, useState } from "react";
import EarningsChart from "./EarningsChart";
import { convertToApproximateString } from "../../Inputs/convert";
import { useMediaQuery, useTheme } from "@mui/material";

const History: React.FC<any> = ({ startDate, endDate, inputs, historyData, getFilteredHistory, loading }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <div
            className="relative flex flex-col group/design-root overflow-x-hidden"
            style={{
                fontFamily: '"Work Sans", "Noto Sans", sans-serif',
                backgroundColor: "black",
            }}
        >
            <div className="layout-container flex h-full grow flex-col">
                <div className="container mx-auto p-6 max-w-[960px] border border-gray-300 rounded-lg shadow-lg">
                    {loading ? (
                        <div
                            style={{
                                marginTop: "50px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                minHeight: "350px",
                            }}
                        >
                            <svg width="400" height="200" viewBox="0 0 400 100">
                                <text x="50%" y="50%" textAnchor="middle" alignmentBaseline="middle" fill="transparent" stroke="black" strokeWidth="2" fontSize="100" strokeDasharray="500" className="animated-text">
                                    NetEx
                                </text>
                                <text x="50%" y="50%" textAnchor="middle" alignmentBaseline="middle" fill="transparent" stroke="#FEC901" strokeWidth="1" fontSize="95" strokeDasharray="250" className="animated-text">
                                    NetEx
                                </text>
                            </svg>
                        </div>
                    ) : (
                        <EarningsChart data={historyData.by_days || []} startDate={startDate} endDate={endDate} inputs={inputs} getFilteredHistory={() => {}} />
                    )}
                    {historyData.combined && (
                        <div
                            style={{
                                display: isMobile ? "block" : "flex",
                                border: "1px solid white",
                                borderRadius: "5px",
                                justifyContent: "space-between",
                                color: "white",
                            }}
                        >
                            <div
                                style={{
                                    padding: "10px",
                                    border: "1px solid white",
                                    borderRadius: "5px",
                                    margin: "10px",
                                }}
                            >
                                <h1>Turnovers</h1>
                                <hr />
                                <br />
                                {Object.entries(historyData.turnovers).map(([currency_name, amount]: any) => {
                                    return (
                                        <p className="text-white" style={{ fontSize: isMobile ? "14px" : "" }}>
                                            {currency_name}: {convertToApproximateString(amount)}
                                        </p>
                                    );
                                })}
                            </div>
                            <div
                                style={{
                                    padding: "10px",
                                    border: "1px solid white",
                                    borderRadius: "5px",
                                    margin: "10px",
                                }}
                            >
                                <h1>Stats</h1>
                                <hr />
                                <br />
                                <p className="text-white" style={{ fontSize: isMobile ? "14px" : "" }}>
                                    Profit: {convertToApproximateString(historyData.combined.profit)}
                                </p>
                                {historyData.combined.loss !== 0 && (
                                    <p className="text-white" style={{ fontSize: isMobile ? "14px" : "" }}>
                                        Loss: {convertToApproximateString(historyData.combined.loss)}
                                    </p>
                                )}
                                {historyData.combined.income !== 0 && (
                                    <p className="text-white" style={{ fontSize: isMobile ? "14px" : "" }}>
                                        Income: {convertToApproximateString(historyData.combined.income)}
                                    </p>
                                )}
                                {historyData.combined.income !== 0 && !process.env.REACT_APP_GETCOIN && (
                                    <p className="text-white" style={{ fontSize: isMobile ? "14px" : "" }}>
                                        Income (Hrach+Artyom): {convertToApproximateString(historyData.incomeHrachArtyom)}
                                    </p>
                                )}
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    border: "1px solid white",
                                    borderRadius: "5px",
                                    margin: "10px",
                                }}
                            >
                                <div style={{ padding: "10px" }}>
                                    <h1>Shares</h1>
                                    <hr />
                                    <br />
                                    {historyData.combined.hrach !== 0 ? (
                                        <p className="text-white" style={{ fontSize: isMobile ? "14px" : "" }}>
                                            {process.env.REACT_APP_GETCOIN ? "GetCoin" : "Hrach"}: {convertToApproximateString(historyData.combined.hrach)}
                                        </p>
                                    ) : (
                                        <p className="text-white" style={{ fontSize: isMobile ? "14px" : "" }}>
                                            {process.env.REACT_APP_GETCOIN ? "GetCoin" : "Hrach"}: 0
                                        </p>
                                    )}
                                    {!process.env.REACT_APP_GETCOIN && (
                                        <>
                                            {historyData.combined.fahad !== 0 ? (
                                                <p className="text-white" style={{ fontSize: isMobile ? "14px" : "" }}>
                                                    Fahad: {convertToApproximateString(historyData.combined.fahad)}
                                                </p>
                                            ) : (
                                                <p className="text-white" style={{ fontSize: isMobile ? "14px" : "" }}>
                                                    Fahad: 0
                                                </p>
                                            )}
                                            {historyData.combined.artyom !== 0 ? (
                                                <p className="text-white" style={{ fontSize: isMobile ? "14px" : "" }}>
                                                    Artyom: {convertToApproximateString(historyData.combined.artyom)}
                                                </p>
                                            ) : (
                                                <p className="text-white" style={{ fontSize: isMobile ? "14px" : "" }}>
                                                    Artyom: 0
                                                </p>
                                            )}
                                        </>
                                    )}
                                </div>
                                <div style={{ padding: "10px" }}>
                                    <h1>Debts</h1>
                                    <hr />
                                    <br />
                                    <p className="text-white" style={{ fontSize: isMobile ? "14px" : "" }}>
                                        {convertToApproximateString(historyData.combined.hrach - historyData.combined.hrach_given)}
                                    </p>
                                    <p className="text-white" style={{ fontSize: isMobile ? "14px" : "" }}>
                                        {convertToApproximateString(historyData.combined.fahad - historyData.combined.fahad_given)}
                                    </p>
                                    {historyData.combined.artyom - historyData.combined.artyom_given !== 0 && historyData.combined.artyom !== 0 ? (
                                        <p className="text-white" style={{ fontSize: isMobile ? "14px" : "" }}>
                                            {convertToApproximateString(historyData.combined.artyom - historyData.combined.artyom_given)}
                                        </p>
                                    ) : (
                                        <p className="text-white" style={{ fontSize: isMobile ? "14px" : "" }}>
                                            0
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default History;
